<template>
  <b-row>
    <b-col cols="12">
      <b-row class="mt-4">
        <b-col>
          By entering the Customer Billing Information and clicking 
          “Complete Order’ below, you authorize Phairify to issue an 
          invoice, agree the named customer will make payment for 
          same, and agree to our
        <a
            href="https://phairify-docs.s3.us-east-2.amazonaws.com/Phairify_Terms_Conditions_Use.pdf"
            target="_blank"
        >
          Terms of Use</a>. See our <a
          href="https://phairify-docs.s3.us-east-2.amazonaws.com/Phairify_Privacy_Policy_2020_09_01.pdf"
          target="_blank"
      > Privacy Policy </a> for details or to opt out at any time.
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col>
          Customer Billing Information:
          <b-row class="mt-4">
            <b-col cols="12">
              <b-form-group
                label="Customer Name *:"
                :invalid-feedback="customerNameInvalidFeedback"
                :state="validateState('customerName')"
              >
                <b-form-input
                  v-model="$v.customerName.$model"
                  type="text"
                  required
                  :state="validateState('customerName')"
                  @input="handleInput"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Customer Billing Contact Email Address *: "
                :invalid-feedback="customerEmailInvalidFeedback"
                :state="validateState('customerEmail')"
              >
                <b-form-input
                  v-model="$v.customerEmail.$model"
                  type="text"
                  required
                  :state="validateState('customerEmail')"
                  @input="handleInput"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Customer Purchase Order # or Job Order # *:"
                :invalid-feedback="orderNumberInvalidFeedback"
                :state="validateState('orderNumber')"
              >
                <b-form-input
                  v-model="$v.orderNumber.$model"
                  type="text"
                  required
                  :state="validateState('orderNumber')"
                  @input="handleInput"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col cols="12">
                  <b-form-group label="Customer Code *:" 
                    :invalid-feedback="couponCodeInvalidFeedback"
                    :state="validateState('couponCode')">
                    <b-form-input v-model="$v.couponCode.$model" :state="validateState('couponCode')" type="text" @input="handleInput" required />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>  
        </b-col>
      </b-row>
      <div v-if="this.$store.state.job_offer">
        <div class="flex-grow-1"></div>
        <div class="flex-grow-1 d-flex align-items-center justify-content-center flex-flow-column">
          <b-button class="btn btn-next" @click="ResetText" :disabled="!isShowReset">
              Reset
          </b-button>
          <b-button @click="completeOrder" class="btn btn-next">
            <template v-if="!completeLoading">Complete order</template>
            <template v-else>
              <b-spinner small />
            </template>
          </b-button>
          <b-button class="btn btn-next" @click="handleCancel">
            Cancel
          </b-button>
        </div>
        <div
          class="flex-grow-1 d-flex align-items-center justify-content-center v2_font_size_28"
        >
          <span class="v2_color_med_gray">Total:</span>&nbsp;
          <span class="v2_color_primary_teal">${{ this.total }}</span>
        </div>
      </div>
      <!---  Payment Success Modal -->
      <b-modal
        v-if="completeOrderModalVisible"
        lazy
        size="lg"
        hide-header-close
        header-class="v2_bg_primary_teal"
        modal-class="font_Montserrat"
        :visible="completeOrderModalVisible"
        hide-footer
      >
        <template slot="modal-header">
          <span
            class="align-self-center my-0 v2_color_white v2_font_weight_semibold v2_font_size_24"
          >
            Payment Success! 
          </span>
        </template>
        <b-row class="center-align-box margin-30">
          <b-col md="6" sm="12"  class="text-center mt-10">
              <b-button class="post_opportunity_btn h-100 max-height-150" variant="v2_primary pt-2 pb-4" @click="goToPage('dashboard')">
              <p class="font_weight_semibold v2_font_size_20">Go To Dashboard</p>
              <p>to Monitor and Manage candidates for your Job Opportunity.</p>
              </b-button>
          </b-col>

          <b-col md="6" class="text-center mt-10">
              <b-button class="post_opportunity_btn max-height-150" variant="v2_primary pt-2 pb-4 h-100" @click="goToPage('inform')">
              <p class="font_weight_semibold v2_font_size_20">Go to Inform </p>
              <p>to assess specialty productivity and compensation data and refine your Job Opportunity</p>
              </b-button>
          </b-col>
        </b-row>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required,minLength,email } from 'vuelidate/lib/validators';
import { alphaNumericValidator } from '@/helpers/customValidators';
//import { alphaSpaceValidator,alphaNumericValidator } from '@/helpers/customValidators';
import Api from '@/providers/Api';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
//import { numeric } from 'vuelidate/lib/validators';

export default {
  name: 'JobOfferInvoiceForm',
  mixins: [validationMixin],
  data() {
    return {
      orderNumber: null,
      couponCode: null,
      customerName: null,
      customerEmail: null,
      job_opportunity_duration:0,
      jobOfferPrice:0,
      total: 0,
      jobOfferId:0,
      duration: 3,
      completeOrderModalVisible:false,
      isCouponUsed: false,
      isCreateJobOffer: false,
      coupon_code_id:null,
      isShowReset:false,
      completeLoading: false,
    };
  },
  validations: {
    orderNumber:{
      required,
      alphaNumericValidator,
      minLength: minLength(5),
      // maxLength: maxLength(8),
    },
    customerName:{
      required,
      minLength: minLength(4),
    },
    customerEmail:{
      required,
      email
    },
    couponCode:{
      required
    },
    duration: {},
  },
  mounted: async function () {
    const jobOpportunityPrice = await Api.getSettingByKey('job_opportunity_price');
    this.total = this.jobOfferPrice = jobOpportunityPrice.value ? jobOpportunityPrice.value : 500;

    const jobOpportunityDuration = await Api.getSettingByKey('job_opportunity_duration');
    this.job_opportunity_duration = jobOpportunityDuration.value ? jobOpportunityDuration.value : 90;
  },
  computed: {
    orderNumberInvalidFeedback: function () {
      if (!this.$v.orderNumber.alphaNumericValidator) {
        return 'Only alphanumeric characters are allowed';
      }
      if (!this.$v.orderNumber.minLength) {
        return 'Order number minimum 5 characters long';
      }
      return 'Order number is required';
    },
    customerNameInvalidFeedback: function () {
      if (!this.$v.customerName.required) {
        return 'Customer name is required';
      }
      // if (!this.$v.customerName.alphaSpaceValidator) {
      //   return 'Only alpha characters are allowed';
      // }
      // if (!this.$v.customerName.alphaNumericValidator) {
      //   return 'Only alphasss characters are allowed';
      // }
      if (!this.$v.customerName.minLength) {
        return 'Customer name must be 4 characters long';
      }
      return ''; // No validation error, return an empty string
    },
    customerEmailInvalidFeedback: function () {
      if (!this.$v.customerEmail.required) {
        return 'Customer email is required';
      }
      if (!this.$v.customerEmail.email) {
        return 'Please enter a valid email address';
      }
      return ''; // No validation error, return an empty string
    },
    couponCodeInvalidFeedback: function(){
      if (!this.$v.couponCode.required) {
        return 'Customer Code is required';
      }
      return '';
    }
  },
  methods: {
    validateState: function (name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    handleInput() {
      this.isShowReset = true;
    },
    ResetText: function () {
      this.orderNumber=null;
      this.couponCode=null;
      this.isShowReset = false;
      this.completeLoading = false;
    },
    completeOrder: async function () {
      this.$v.$touch();

      if (this.$v.$anyError) {
        return;
      }

      this.completeLoading = true;
      try {
          const keyMapping = {
          "title": "title",
          "description": "description", // Here, the typo in the key is retained as "descriotn" as per your requirement.
          "tracking": "tracking_num", // Renaming "tracking" to "tracking_nume"
          "jobBoardUrl": "external_url", // Renaming "jobBoardUrl" to "external_url"
          "company": "company_name", // Renaming "company" to "company_name"
          //"zipCode": "location_zip_code", // Renaming "zipCode" to "job_location_pincode"
          "welcome_message": "welcome_message", // Retaining the same key "welcome_message"
          "practice_name":"practice_name"
        };
        if(this.couponCode)
        {
          try {
            const couponData = await Api.getCouponDiscountIfExist(this.couponCode,this.total);
            this.total = couponData.coupon_discount;
            this.coupon_code_id = couponData.coupon_code_id;
            this.isCouponUsed = false;
          }catch (error) {
            this.isCouponUsed = true;
            this.completeLoading = false;
            handleServerErrorWithValidation(error, this.$toasted);
          }
        }
        const jobInformation = this.$store.state.job_information;
      
        const usedCouponCode = this.couponCode ? this.couponCode : '';
       
        if(!this.couponCode || this.couponCode == ''){
          this.isCreateJobOffer = true;
        }else if(this.couponCode && !this.isCouponUsed){
          this.isCreateJobOffer = true;
        }else{
          this.isCreateJobOffer = false;
        }
        if(this.isCreateJobOffer){  
          const jobOfferData = this.$store.state.job_offer;

          const data = this.transformAndMergeData(keyMapping,jobInformation, jobOfferData, this.job_opportunity_duration, this.total,usedCouponCode);
          this.jobOfferId = await Api.createJobOfferData(data, 0);

          this.$store.state.job_offer = undefined;
          this.$store.state.job_information = undefined;
          this.$store.state.show_payment_page = '';
          this.$store.state.is_new_offer = undefined;
          this.$store.state.location_zip_code = undefined;
          this.$store.state.specialtyId = undefined;
          localStorage.removeItem('job_offer_signup_data');

          const jobOffer = await Api.invoiceJobOffer({
            amount: this.total,
            duration: this.duration,
            job_id : this.jobOfferId.id,
            coupon: (this.couponCode) ? this.couponCode : '', 
          });

          this.$toasted.success('Job Offer created successfully', { duration: 3000 });
          this.$emit('job-offer-paid', jobOffer);
          this.completeOrderModalVisible=true;
        }
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        // this[loadingVarName] = false;
        // this.createJobModalVisible = false;
      }
    },
    transformAndMergeData: function(keyMapping,jobInformation, jobOffer, jobOpportunityDuration, jobOfferPrice,couponCode) {
      // Transform jobInformation data using the key mapping
      const transformedData = Object.fromEntries(
        Object.entries(jobInformation).map(([oldKey, value]) => [keyMapping[oldKey] || oldKey, value])
      );
      const firstElementValue = jobOffer[0].value;
      const secondElementValue = jobOffer[1].value;
      const modifiedFirstElementValue = {
      ...firstElementValue,
      ...secondElementValue,
        subspecialty_id: firstElementValue.subspecialtyId,
        specialty_id: firstElementValue.specialtyId,
        job_offer_duration: jobOpportunityDuration,
        job_offer_price: jobOfferPrice,
        coupon_code: couponCode,
        payment_method:"invoice",
        job_order_no : this.orderNumber,
        coupon_code_id:this.coupon_code_id,
        customer_name:this.customerName,
        customer_email:this.customerEmail,
      };
      // Merge the first element's "value" key from jobOffer with transformedData
      const mergedData = { ...transformedData, ...modifiedFirstElementValue };

      mergedData.jobQuestions = jobOffer.filter(item => item.type !== "JOB_INFORMATION" && item.type !== "LOCATION" && item.type !== 'SPECIALTY');

      return mergedData;
    },
    handleCancel: function () {
      this.$emit('updatePropValue', 3);
      this.$store.state.job_offer=undefined;
      this.$store.state.is_change_criteria=undefined;
      this.$store.state.is_new_offer=undefined;
      this.$store.state.location_zip_code=undefined;
      this.$store.state.set_job_information = undefined;
      this.$store.state.specialtyId = undefined;
      this.$store.state.isComeFromIco = undefined;
      this.$store.state.is_change_criteria=undefined;
      this.$router.go(0); 
    },
    goToPage: function (page) {
        if(page=='inform')
        {
            this.$router.push('/recruiter/inform');
        }else{
            this.$router.push('/recruiter');
        }
    },
  }
};
</script>

<style scoped lang="scss">
@import '../../../../sass/variables_mixins.scss';
.v2_bg_primary_teal {
  background-color: $phairify_v2_color_primary_teal;
}
.btn-next{
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-height: 30px;
  font: normal normal 550 16px/24px;
  letter-spacing: 0;
  color: #00586f !important;
  background-color: #99c555 !important;
  border: 1px solid #00586f !important;
  opacity: 1;
  max-width: 180px;
	width: 100%;
	justify-content: center;
	margin: 10px;
  border-radius: 0;
}
.btn-next:hover{
  background-color: #b0d27b !important;
}
.btn-next i{
  font-size:15px;
}
.btn-next:disabled{
  background-color:#DEE9EC !important;
  outline-color:rgba(77,88,88,0.5);
  border:1px solid #00586f !important;
  cursor: not-allowed;
}
.post_opportunity_btn{
  display: flex;
  align-items: center;
  flex-flow: column;
  height: unset;
}
.post_opportunity_btn p {
  line-height: 18px;
  margin-bottom: 0;
  padding-top: 20px;
}
.max-height-150{
    max-height: 150px;
}
.margin-30{
  margin: 30px;
}
.mt-10{
  margin-top:10px;
}
</style>
